/**
 * Network configuration for blockchain interactions
 * Shared between frontend and backend (Cloudflare Workers/Pages compatible)
 */

export type NetworkName = 'base-sepolia' | 'base'

export interface BaseNetworkConfig {
  name: NetworkName
  chainId: number
  usdcAddress: string
  displayName: string
  isTestnet: boolean
}

// USDC contract addresses by network
export const USDC_ADDRESSES: Record<NetworkName, string> = {
  'base-sepolia': '0x036CbD53842c5426634e7929541eC2318f3dCF7e',
  base: '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
}

// Base network configurations (shared properties)
export const BASE_NETWORKS: Record<NetworkName, BaseNetworkConfig> = {
  'base-sepolia': {
    name: 'base-sepolia',
    chainId: 84532,
    usdcAddress: USDC_ADDRESSES['base-sepolia'],
    displayName: 'Base Sepolia',
    isTestnet: true,
  },
  base: {
    name: 'base',
    chainId: 8453,
    usdcAddress: USDC_ADDRESSES.base,
    displayName: 'Base',
    isTestnet: false,
  },
}

/**
 * Estimated gas costs for operations (in ETH)
 */
export const GAS_ESTIMATES = {
  USDC_TRANSFER: 0.0001, // Approximate gas for USDC transfer
}
